export type MuscleDistribution = {
  district: string;
  percentage: number;
};

export const FATICA_SISTEMICA = {
  ELEVATA: "ELEVATA",
  MEDIA: "MEDIA",
  BASSA: "BASSA",
} as const;

export const PROFILO_RESISTENZA = {
  ALLUNGAMENTO: "ALLUNGAMENTO",
  ACCORCIAMENTO: "ACCORCIAMENTO",
  NEUTRO: "NEUTRO",
  OTTIMALE: "OTTIMALE",
} as const;

export type Exercise = {
  id: string;
  name: string;
  tags: string[];
  type: keyof typeof EXERCISE_TYPES;
  notes?: string;
  videoUrls: string[];
  muscleDistribution?: MuscleDistribution[];
  specialCategoryId?: number;
  checkDistrict?: string;
  faticaSistemica?: string;
  profiloResistenza?: string;
  idContainer?: number | null;
};
export const EXERCISE_TYPES = {
  DEFAULT: "DEFAULT",
  SUPERSET: "SUPERSET",
  STRIPPING: "STRIPPING",
} as const;

export const EXERCISE_TAGS = {
  FULL_BODY: "FULL_BODY",
  UPPER_BODY: "UPPER_BODY",
  LOWER_BODY: "LOWER_BODY",
} as const;

export type ExercisesResponse = ExerciseFromApi[];

export type ExerciseFromApi = {
  id: string;
  desc: string;
  exercisesData: string;
  type: keyof typeof EXERCISE_TYPES;
  note?: string;
  link?: string;
  sets: string[];
  idContainer?: number | null;
};

export type ExerciseRequest = Omit<ExerciseFromApi, "id">;

export type ExerciseContainer = {
  id: number;
  name: string;
  color?: string;
  parentId?: number | null;
};

export type ExerciseContainerFromApi = {
  id: number;
  name: string;
  idUser?: number;
  color?: string;
  parentId?: number | null;
};
